import { Http } from "../axios/interceptors";

export const getAllAzureArqu = async (param) =>
  Http("GET", `/ArquitecturaAzure/GetList?`, param);

export const getAzureArqu = async (id) =>
  Http("GET", `/ArquitecturaAzure/Get?idArquitecturaAzure=${id}`);

export const createAzureArqu = async (guid) =>
  Http("POST", `/Services/Get?guid=${guid}`);

// export const createOrEditAzureArqu = async (body, id = null) => (id ? Http('PUT', `/ArquitecturaAzure/Update`, null, body) : Http('POST', '/ArquitecturaAzure/Create', null, body))

export const createOrEditAzureArqu = async (body, id = null) =>
  id
    ? Http("PUT", `/ArquitecturaAzure/Update`, null, body)
    : Http("POST", "/ArquitecturaAzure/CreateContenedorAzure", null, body);
export const deleteAzureArqu = async (guid) =>
  Http("DELETE", `/ArquitecturaAzure/Delete?idArquitecturaAzure=${guid}`);

export const startBot = async (guid) =>
  Http("GET", `/ArquitecturaAzure/StartBot?guidCompany=${guid}`);

export const stopBot = async (guid) =>
  Http("GET", `/ArquitecturaAzure/StoptBot?guidCompany=${guid}`);
